import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBuilding, FaFolderOpen, FaBook, FaCheckSquare, FaKey, FaTerminal, FaPaperclip, FaLink, FaArchive, FaCalendarWeek, FaTags, FaKeyboard } from "react-icons/fa";
import { PROJECTS_CONSTANTS } from "../../_Projects/_MODULES/_API";
import { COMPANIES_CONSTANTS } from "../../_Companies/_MODULES/_API";
import { TAGS_CONSTANTS } from "../../_Tags/_MODULES/_API";
import { COMMAND_TOTALS } from "../../_Commands/_DATA/commandsCatalog.data";
import { PageHeader } from "../../../../../_CORE/APP/Templates/_UI/PageHeader/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { MetricCard, MetricGrid } from "../../../../../_CORE/APP/Templates/_UI/Metrics/_index";
import { useApiQuery } from "../../../../../_CORE/APP/Hooks/Hooks/_Records/_useApiQuery";
import { ViewLayout } from "../../../../_UI/ViewLayout";
import "../_UI/_Styles/Dashboard.css";

export const DashboardViewMain = () => {

    const { apiGet: onGetDashboard, useApiData: DASHBOARD, useApiLoading: IS_LOADING } = useApiQuery({
        minTimeQuery: 300, enablePagination: false, startLoading: true,
    });

    const { apiGet: onGetCompanies, useApiData: COMPANIES } = useApiQuery({
        minTimeQuery: 300, enablePagination: false,
    });

    const { apiGet: onGetTags, useApiData: TAGS, useApiLoading: TAGS_LOADING } = useApiQuery({
        minTimeQuery: 220, enablePagination: false,
    });

    useEffect(() => {
        onGetDashboard({ endpoint: PROJECTS_CONSTANTS.DASHBOARD, isDetail: true });
        onGetCompanies({ endpoint: COMPANIES_CONSTANTS.LIST });
        onGetTags({ endpoint: TAGS_CONSTANTS.LIST });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const BY_STATUS = DASHBOARD?.byStatus ?? {};

    const ARCHIVED = DASHBOARD?.archived ?? {};

    const ARCHIVED_TOTAL = (ARCHIVED.projects ?? 0) + (ARCHIVED.subProjects ?? 0) + (ARCHIVED.logbook ?? 0);

    const ACTIVIDAD = DASHBOARD?.activity ?? {};

    return (
        <ViewLayout
            header={
                <PageHeader
                title="Panel"
                description="Resumen de compañías, proyectos, comandos, bitácora, tareas y etiquetas de tu espacio de trabajo."
                    actions={
                        <>
                            <AppButton to="/companies" variant="outline" tone="neutral" icon={<FaBuilding />}>Compañías</AppButton>
                            <AppButton to="/projects" icon={<FaFolderOpen />}>Proyectos</AppButton>
                        </>
                    } />
            } >

            <h2 className="LStudio__app_view_metrics_title">Resumen general</h2>

            <MetricGrid columns="auto">

                <MetricCard label="Compañías" value={COMPANIES?.length ?? 0}
                    icon={<FaBuilding />} tone="neutral" isLoading={IS_LOADING} />

                <MetricCard label="Proyectos" value={DASHBOARD?.totalProjects ?? 0}
                    icon={<FaFolderOpen />} tone="accent" isLoading={IS_LOADING}
                    footer={`${BY_STATUS.ACTIVE ?? 0} activos · ${BY_STATUS.PAUSED ?? 0} pausados · ${BY_STATUS.FINISHED ?? 0} terminados`} />

                <MetricCard label="Etiquetas" value={Array.isArray(TAGS) ? TAGS.length : 0}
                    icon={<FaTags />} tone="neutral" isLoading={IS_LOADING || TAGS_LOADING} to="/tags"
                    footer="Clasificación reutilizable para organizar tu trabajo" />

                <MetricCard label="Entradas de bitácora" value={DASHBOARD?.totalLogbook ?? 0}
                    icon={<FaBook />} tone="accent" isLoading={IS_LOADING}
                    footer={`${DASHBOARD?.openIssues ?? 0} sin resolver`} />

                <MetricCard label="Comandos" value={COMMAND_TOTALS.total}
                    icon={<FaKeyboard />} tone="neutral" isLoading={false} to="/commands"
                    footer={`${COMMAND_TOTALS.basic} básicos · ${COMMAND_TOTALS.intermediate} intermedios · ${COMMAND_TOTALS.advanced} avanzados`} />

                <MetricCard label="Tareas pendientes" value={DASHBOARD?.pendingTodos ?? 0}
                    icon={<FaCheckSquare />} tone="warn" isLoading={IS_LOADING}
                    footer={`${DASHBOARD?.totalTodos ?? 0} en total`} />

                <MetricCard label="Credenciales" value={DASHBOARD?.totalCredentials ?? 0}
                    icon={<FaKey />} tone="neutral" isLoading={IS_LOADING}
                    footer={`${DASHBOARD?.totalEnvironments ?? 0} entornos`} />

                <MetricCard label="Scripts" value={DASHBOARD?.totalSnippets ?? 0}
                    icon={<FaTerminal />} tone="neutral" isLoading={IS_LOADING} />

                <MetricCard label="Archivos" value={DASHBOARD?.totalDocuments ?? 0}
                    icon={<FaPaperclip />} tone="neutral" isLoading={IS_LOADING} />

                <MetricCard label="Enlaces" value={DASHBOARD?.totalLinks ?? 0}
                    icon={<FaLink />} tone="neutral" isLoading={IS_LOADING} />

                <MetricCard label="Archivados" value={ARCHIVED_TOTAL}
                    icon={<FaArchive />} tone="warn" isLoading={IS_LOADING} to="/archive"
                    footer={`${ARCHIVED.projects ?? 0} proyectos · ${ARCHIVED.subProjects ?? 0} subproyectos · ${ARCHIVED.logbook ?? 0} entradas`} />

            </MetricGrid>

            <h2 className="LStudio__app_view_metrics_title">Actividad reciente</h2>

            <MetricGrid columns="auto">

                <MetricCard label="Proyectos nuevos" value={ACTIVIDAD.projects?.week ?? 0}
                    icon={<FaCalendarWeek />} tone="accent" isLoading={IS_LOADING}
                    footer={`${ACTIVIDAD.projects?.month ?? 0} en el mes · ${ACTIVIDAD.projects?.year ?? 0} en el año`} />

                <MetricCard label="Entradas esta semana" value={ACTIVIDAD.logbook?.week ?? 0}
                    icon={<FaBook />} tone="accent" isLoading={IS_LOADING}
                    footer={`${ACTIVIDAD.logbook?.month ?? 0} en el mes · ${ACTIVIDAD.logbook?.year ?? 0} en el año`} />

                <MetricCard label="Tareas creadas" value={ACTIVIDAD.todos?.week ?? 0}
                    icon={<FaCheckSquare />} tone="neutral" isLoading={IS_LOADING}
                    footer={`${ACTIVIDAD.todos?.month ?? 0} en el mes · ${ACTIVIDAD.todos?.year ?? 0} en el año`} />

                <MetricCard label="Tareas terminadas" value={ACTIVIDAD.todos?.doneWeek ?? 0}
                    icon={<FaCheckSquare />} tone="ok" isLoading={IS_LOADING}
                    footer={`${ACTIVIDAD.todos?.doneMonth ?? 0} en el mes`} />

            </MetricGrid>

            {
                COMPANIES?.length > 0 && (
                    <section className="LStudio__app_dashboard_recent">

                        <h2 className="LStudio__app_dashboard_recent_title">Proyectos por compañía</h2>

                        <div className="LStudio__app_dashboard_recent_grid">
                            {
                                COMPANIES.map((company) => (
                                    <Link key={company.id} to={`/companies/${company.id}`}
                                        className="LStudio__app_dashboard_recent_item">

                                        <span className="LStudio__app_dashboard_recent_company">{company.name}</span>

                                        <span className="LStudio__app_dashboard_recent_count">
                                            {company.projects?.length ?? 0} proyectos
                                        </span>

                                    </Link>
                                ))
                            }
                        </div>

                    </section>
                )
            }
        </ViewLayout>
    );
};
